import Skeleton from '@mui/material/Skeleton';

export default ({ fullPage = true }) => {
  return (
    <div>
      {fullPage && (
				<>
				<Skeleton variant="rectangular" width={210} height={118} />
				<Skeleton variant="rectangular" width={240} height={118} />
        </>
			)}
		<Skeleton variant="rectangular" width={210} height={40} />
		<Skeleton variant="rectangular" width={150} height={50} />
		<Skeleton variant="rectangular" width={250} height={118} />
		<Skeleton variant="rectangular" width={220} height={10} />
		<Skeleton variant="rectangular" width={80} height={50} />
		<Skeleton variant="rectangular" width={120} height={60} />
    </div>
  );
};
